import React from "react";
import "./App.css";
import Home from "./actions/views/home";

function App() {
  return (
    <div className="app">
      <div className="app-container">
        <Home />
      </div>
    </div>
  );
}

export default App;
